import { AddressValue } from '@/lib/types/VCardT'

export const buildAddressString = (address: AddressValue): string => {
  const parts: string[] = []
  if (address.street1) parts.push(address.street1)
  if (address.street2) parts.push(address.street2)
  if (address.city) parts.push(address.city)
  if (address.state) parts.push(address.state)
  if (address.postal) parts.push(address.postal)
  if (address.country) parts.push(address.country)
  return parts.filter(Boolean).join(', ')
}
